import { render, staticRenderFns } from "./take-survey.vue?vue&type=template&id=5189b7c4&scoped=true&"
import script from "./take-survey.vue?vue&type=script&lang=js&"
export * from "./take-survey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5189b7c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5189b7c4')) {
      api.createRecord('5189b7c4', component.options)
    } else {
      api.reload('5189b7c4', component.options)
    }
    module.hot.accept("./take-survey.vue?vue&type=template&id=5189b7c4&scoped=true&", function () {
      api.rerender('5189b7c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/surveys/take-survey.vue"
export default component.exports